import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { Col, Row, Table } from "antd";
import { columnsData } from "./columns";
import { getApis } from "../common/api";
import { vehiclePartsDetailsListApiUrl } from "../common/endpoints";
import "./style.css";

const partsHistoryData = (data) => {
  const grouped = {};

  data.forEach((item) => {
    const { partName } = item;
    if (!grouped[partName]) {
      grouped[partName] = [];
    }
    grouped[partName].push(item);
  });

  const result = [];

  Object.values(grouped).forEach((items) => {
    const current = items.find((item) => item.endTime === null);
    const history = items.filter((item) => item.endTime !== null);

    if (current) {
      if (history.length > 0) {
        current.children = history;
      }
      result.push(current);
    } else {
      result.push(...history);
    }
  });

  return result;
};

const VehicleParts = () => {
  const location = useLocation();
  let { vehId } = location?.state || {};
  const authToken = localStorage.getItem("authToken");
  const orgDetails = useSelector((state) => state.org);
  const [vehiclesTableData, setVehiclesTableData] = useState({
    list: [],
    totalElements: 0,
    loading: true,
  });

  const getVehiclePartDetailsList = useCallback(async () => {
    await getApis(
      vehiclePartsDetailsListApiUrl.replace("{vehicleId}", vehId),
      {},
      authToken
    )
      .then((response) => {
        setVehiclesTableData((prev) => ({
          ...prev,
          list: response?.data ? partsHistoryData(response?.data) : [],
          totalElements: response?.data?.totalElements,
          loading: false,
        }));
      })
      .catch((error) => {
        console.log(error);
        setVehiclesTableData((prev) => ({
          ...prev,
          list: [],
          totalElements: 0,
          loading: false,
        }));
      });

    // eslint-disable-next-line
  }, [authToken, orgDetails?.id]);

  useEffect(() => {
    getVehiclePartDetailsList();
  }, [getVehiclePartDetailsList]);

  const columns = columnsData();

  return (
    <>
      <Row justify="space-between" className="flex-center">
        <Col span={10} className="head">
          Vehicle Details
        </Col>
      </Row>
      <Row justify="center" className="mt1">
        <Col span={24}>
          <Table
            columns={columns}
            // rowHoverable={false}
            scroll={{ x: "600px" }}
            rowKey={(record) => record?.partId}
            dataSource={vehiclesTableData?.list}
            className="vehicles-parts-list-table"
            pagination={{ pageSize: 10 }}
            rowClassName={(record) =>
              record?.children ? "cursor-pointer" : ""
            }
            expandable={{
              expandRowByClick: true,
              rowExpandable: (record) => record?.children,
              expandIcon: ({ expanded, onExpand, record }) =>
                record?.children ? (
                  expanded ? (
                    <UpOutlined
                      onClick={() => onExpand(expanded, record)}
                      className="mr1"
                    />
                  ) : (
                    <DownOutlined
                      onClick={() => onExpand(expanded, record)}
                      className="mr1"
                    />
                  )
                ) : null,
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default VehicleParts;
